<div class="main-discription">
    <span class="ltms-description">{{ mainDiscription }}</span>
    <span [ngStyle]="{'opacity': isHideClearAllSelection ? '0.5' : '1'}" class="clear-all-selections-button" (click)="clickOnClearAllSelections()">Clear all selections</span>
</div>
<div class="filter">
    <div class="main-dropdown">
        <span class="dropdown-text">Compare</span>
        <app-score-dropdown-menu #dropdownChild1 [config]="compareDropdown.config" [selectedOption]="compareDropdown?.selectedOption" [options]="compareDropdown?.options" (selectedOptionChange)="dropdownOptionChange($event, 'comparision')"></app-score-dropdown-menu>
        <span class="dropdown-text selected-option">{{ selectedOption }}</span>
    </div>
    <span class="main-discription-actions">
        <app-score-comparison-toggle [visible]="isComparisonAvailable" [showComparisonFlag]="showComparisonFlag" [dateType]="dateType" [checkboxId]="'scoreComparisonTabCheckbox'" (showComparisonChange)="onShowComparisonChange($event)"></app-score-comparison-toggle>
        <app-score-widget [config]="widgetTool" (onDownloadClick)="onDownload()"></app-score-widget>
    </span>
</div>
<div class="compare-table">
    <div class="card card-one">
        <div class="cardHeader">
            <div class="cardHeader-filter">
                <span class="cardHeader-filter-text">Choose a Distribution</span>
                <span class="card-dropdown"><app-score-dropdown-menu #dropdownChild2 [config]="distributionDropdown.config" [selectedOption]="distributionDropdown?.selectedOption" [options]="distributionDropdown?.options" (selectedOptionChange)="dropdownOptionChange($event, 'distribution')"></app-score-dropdown-menu></span>
            </div>
            <div class="cardHeader-widget">
                <span><app-score-search-bar #child1 [config]="{width: 180, 'placeholder': 'Search ' + distributionSearchPlaceHolder }" (onSearch)="onSearch($event, 'distribution')"></app-score-search-bar></span>
            </div>
        </div>
        <div class="empty-card" *ngIf="isEmptyCardShow">
            <div class="empty-card-message">To compare, please select an option from the Compare dropdown followed by a Distribution</div>
        </div>
        <ng-container *ngIf="!isEmptyCardShow">
            <div class="table">
                <div class="loader" *ngIf="isCardOneLoading">
                    <app-ltms-loader></app-ltms-loader>
                </div>
                <div class="error" *ngIf="!isCardOneLoading && isCardOneError">
                    <app-ltms-error [code]="'404'"></app-ltms-error>
                </div>
                <app-score-table *ngIf="!isCardOneLoading && !isCardOneError" [tablePlugins]="distributionTable.tablePlugins" [tableColumns]="distributionTable.tableHeader" [tableData]="distributionTable.tableRow" [tableFooter]="distributionTable.tableFooter" [searchText]="searchDistributionText" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel"></app-score-table>
            </div>
        </ng-container>
    </div>
    <div class="card card-two">
        <div class="cardHeader">
            <div class="cardHeader-filter">
                <span class="cardHeader-filter-text">Compare with</span>
                <span class="card-dropdown"><app-score-dropdown-menu #dropdownChild3 [config]="compareWithDropdown.config" [selectedOption]="compareWithDropdown?.selectedOption" [options]="compareWithDropdown?.options" (selectedOptionChange)="dropdownOptionChange($event, 'compareWith')"></app-score-dropdown-menu></span>
            </div>
            <div class="cardHeader-widget">
                <span><app-score-search-bar #child2 [config]="{width: 180, 'placeholder': 'Search ' + compareWithSearchPlaceHolder}" (onSearch)="onSearch($event, 'compareWith')"></app-score-search-bar></span>
            </div>
        </div>
        <div *ngIf="isEmptyCardShow" class="empty-card" [ngStyle]="{'height': isEmptyCardShow ? '300px' : 'auto'}"></div>
        <div *ngIf="!isEmptyCardShow && compareWithSearchPlaceHolder" class="table">
            <div class="loader" *ngIf="isCardTwoLoading">
                <app-ltms-loader></app-ltms-loader>
            </div>
            <div class="error" *ngIf="!isCardTwoLoading && isCardTwoError">
                <app-ltms-error [code]="'404'"></app-ltms-error>
            </div>
            <app-score-table *ngIf="!isCardTwoLoading && !isCardTwoError" [tablePlugins]="comapreWithTable.tablePlugins" [tableColumns]="comapreWithTable.tableHeader" [tableData]="comapreWithTable.tableRow" [tableFooter]="comapreWithTable.tableFooter" [searchText]="searchcompareWithText" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel"></app-score-table>
        </div>
    </div>
</div>